import { type AttributeDef } from '@/api/credentialSchemas';
import { type CredentialPayload } from '@/crypto/sodium';

export function EyeIcon({ open }: { open: boolean }) {
  return open ? (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-4 h-4"
      aria-hidden="true"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ) : (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-4 h-4"
      aria-hidden="true"
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
      <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  );
}

export function Row({
  label,
  value,
  mono,
  reveal,
}: {
  label: string;
  value: string | null | undefined;
  mono?: boolean;
  reveal?: boolean;
}) {
  return (
    <div className="flex justify-between items-start gap-4 border-b border-[var(--border)] pb-2 last:border-0">
      <dt className="text-[var(--text-muted)] text-xs uppercase flex-shrink-0">{label}</dt>
      <dd
        className={`${mono ? 'font-mono' : ''} ${reveal ? 'break-all' : ''} text-right text-sm text-[var(--text)]`}
      >
        {value || <span className="text-[var(--text-dim)]">—</span>}
      </dd>
    </div>
  );
}

export function metaValueToString(v: unknown): string | null {
  if (v === null || v === undefined || v === '') return null;
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'boolean') return String(v);
  return JSON.stringify(v);
}

/** Fallback pentru credentialele vechi scrise înainte de schema-uri —
 *  încearcă să recunoască câmpurile tipice. */
export function inferFallbackSecretAttrs(plain: CredentialPayload): AttributeDef[] {
  const defs: AttributeDef[] = [];
  for (const key of Object.keys(plain)) {
    const isTextarea = key === 'notes' || key === 'content' || key === 'private_key';
    defs.push({
      key,
      label: key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' '),
      type: isTextarea ? 'textarea' : 'secret',
      required: false,
      secret: true,
    });
  }
  return defs;
}
